import type { ComponentFeatureFlipperORObject, ComponentFeatureFlippers } from "../types";

/**
 * This method is used to determine if a feature flipper is an object with an OR property.
 *
 * @param feature The feature flipper to check
 * @returns boolean indicating if the feature flipper is an object with an OR property
 */
export const isFeatureORObject = (
  feature: ComponentFeatureFlippers
): feature is ComponentFeatureFlipperORObject => {
  return !!feature && typeof feature === "object" && "OR" in feature;
};
